import type { Router } from 'vue-router'
import { useDomainManagementStore } from '@/modules/domainManagement/store'

export default (router: Router) => {
  router.addRoute({
    path: '/manage/domain/:id',
    name: 'DomainManagementPage',
    component: () => import('@/modules/domainManagement/views/DomainManagementPage.vue'),
    children: [
      {
        path: '',
        name: 'DomainManagementOverview',
        component: () => import('@/modules/domainManagement/views/DomainManagementOverview.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/registrar-lock',
        name: 'DomainManagementRegistrarLock',
        component: () => import('@/modules/domainManagement/views/DomainManagementRegistrarLock.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/get-epp',
        name: 'DomainManagementGetEPPCode',
        component: () => import('@/modules/domainManagement/views/DomainManagementGetEPPCode.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/autorenew',
        name: 'DomainManagementAutorenew',
        component: () => import('@/modules/domainManagement/views/DomainManagementAutorenew.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/nameservers',
        name: 'DomainManagementNameservers',
        component: () => import('@/modules/domainManagement/views/DomainManagementNameservers.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/private-nameservers',
        name: 'DomainManagementPrivateNameservers',
        component: () => import('@/modules/domainManagement/views/DomainManagementPrivateNameservers.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/contact-information',
        name: 'DomainManagementContactInformation',
        component: () => import('@/modules/domainManagement/views/DomainManagementContactInformation.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/dns-manage',
        name: 'DomainManagementDNS',
        component: () => import('@/modules/domainManagement/views/DomainManagementDNS.vue'),
        beforeEnter: async (to, from, next) => {
          const domainManagementStore = useDomainManagementStore()
          const domainId = Number(to.params.id)

          if (!domainManagementStore.domain || domainManagementStore.domain.id !== domainId) {
            await domainManagementStore.getDomain(domainId)
          }

          next()
        },
        meta: {
          layout: 'DefaultLayout',
        },
      },
      {
        path: '/manage/domain/:id/renew',
        name: 'DomainManagementRenew',
        component: () => import('@/modules/domainManagement/views/DomainManagementRenew.vue'),
        meta: {
          layout: 'DefaultLayout',
        },
      },
    ],
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
